import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const FlyoutCard = styled.div`
  width: 440px;
  max-width: 92vw;
  background: ${COLORS.white};
  border-radius: ${RADII.card};
  display: flex;
  flex-direction: column;
`

export const FlyoutBody = styled.div`
  padding: 16px 20px 0;
  max-height: calc(100vh - 140px);
  overflow-y: auto;
  ${customizeVerticalScrollbarThumbMixin()}
`

export const FlyoutFooter = styled.div`
  padding: 12px 20px 16px;
  display: flex;
  justify-content: flex-end;
`

export const ClearAllButton = styled.button`
  height: 36px;
  padding: 0 16px;
  border: 1px solid ${COLORS.borderColor};
  border-radius: ${RADII.item};
  background: ${COLORS.white};
  color: ${COLORS.secondarySemiDark};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background: ${COLORS.fill};
    border-color: ${COLORS.borderHover};
  }
`
